/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Chcete-li získat výhodu z vaší promoce, zadejte aktivní promocní kód, který najdete na této stránce v okamžiku platby. Obdržíte procento slevy zobrazené na vašem nákupu.`
};

const da_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `For at benytte dit tilbud, indtast den aktive rabatkode fra denne side ved betaling. Du får den viste rabat på dit køb.`
};

const de_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Um Ihr Angebot zu nutzen, geben Sie den auf dieser Seite gefundenen Rabattcode beim Bezahlen ein. Sie erhalten den angegebenen Rabatt auf Ihren Einkauf.`
};

const en_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `To benefit from your promotional offer, enter the active discount code you find on this page at checkout. You will receive the discount percentage shown on your purchase.`
};

const es_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Para beneficiarte de tu oferta promocional, introduce el código promocional activo que encontrarás en esta página en el momento del pago. Recibirás el porcentaje de descuento indicado en tu compra.`
};

const fr_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Pour bénéficier de votre offre promotionnelle, saisissez le code promotionnel actif que vous trouverez sur cette page au moment du paiement. Vous recevrez le pourcentage de remise affiché sur votre achat.`
};

const hu_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `A promóciós ajánlat felhasználásához a fizetéskor adja meg az ezen az oldalon talált aktív promóciós kódot. Megkapod az ajánlatban megjelenített kedvezmény százalékát a vásárlásodra.`
};

const it_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Per usufruire della promozione, inserisci il codice sconto attivo che trovi in questa pagina al momento del pagamento. Riceverai la percentuale di sconto indicata sul tuo acquisto.`
};

const nl_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Voer de actieve kortingscode van deze pagina in bij het afrekenen om van de korting te profiteren.`
};

const pl_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Aby skorzystać z promocji, wpisz aktywny kod rabatowy z tej strony podczas płatności. Otrzymasz wskazany rabat.`
};

const pt_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `Para aproveitar sua oferta promocional, insira o código promocional ativo encontrado nesta página no momento do pagamento. Você receberá o percentual de desconto exibido na sua compra.`
};

const sv_discount_codes_how_to_use = /** @type {(inputs: {}) => string} */ () => {
	return `För att använda din rabatt, ange den aktiva rabattkoden från denna sida vid betalning. Du får den angivna rabatten på ditt köp.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_how_to_use = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_how_to_use(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_how_to_use", locale)
	if (locale === "cs") return cs_discount_codes_how_to_use(inputs)
	if (locale === "da") return da_discount_codes_how_to_use(inputs)
	if (locale === "de") return de_discount_codes_how_to_use(inputs)
	if (locale === "en") return en_discount_codes_how_to_use(inputs)
	if (locale === "es") return es_discount_codes_how_to_use(inputs)
	if (locale === "fr") return fr_discount_codes_how_to_use(inputs)
	if (locale === "hu") return hu_discount_codes_how_to_use(inputs)
	if (locale === "it") return it_discount_codes_how_to_use(inputs)
	if (locale === "nl") return nl_discount_codes_how_to_use(inputs)
	if (locale === "pl") return pl_discount_codes_how_to_use(inputs)
	if (locale === "pt") return pt_discount_codes_how_to_use(inputs)
	return sv_discount_codes_how_to_use(inputs)
};
export { discount_codes_how_to_use as "discount_codes.how_to_use" }